module.exports = __webpack_public_path__ + "img/chevy-new.8e6761c3.png";